<template>
<div class="preabs">

    <topheader back="back">
        <template v-slot:info>
            <span>Support</span>
        </template>

		<template v-slot:right>

			

			<div class="buttonpanel">
				<a href="mailto:support@snippity.app">
					<i class="fa-solid fa-at"></i>
				</a>
			</div>
		
		</template>

    </topheader>

</div>
</template>

<style lang="sass" scoped>

::v-deep
	#maincontent
		bottom: 76px!important

iframe
	position: absolute
	left: 0
	top : 0
	bottom : 0
	right: 0
	width: 100%
	height: 100%
</style>

<script>
export default {
    name: 'support_page',
    components: {

    },

    computed: {

    },

    methods: {

    },

    mounted() {

    }
}
</script>
